import { createContext, useCallback, useContext, useState } from "react";

// Shared by the Trading page's tabs:
// - refreshKey / notifyChanged: after a buy/sell/close in any tab,
//   notifyChanged() bumps refreshKey, and the KPIs and every tab that lists
//   that data reload (useEffect on refreshKey).
// - openStrategy(strategyId, instrument): switches to that instrument's
//   Strategies tab and opens the strategy in the drawer.
export const TradingRefreshContext = createContext(null);

// outside the Trading page each component refreshes only itself and can't
// open strategies (openStrategy is undefined)
export const useTradingRefresh = () => {
  const shared = useContext(TradingRefreshContext);
  const [localKey, setLocalKey] = useState(0);
  const notifyLocal = useCallback(() => setLocalKey((key) => key + 1), []);
  return shared || { refreshKey: localKey, notifyChanged: notifyLocal };
};
